import { roomData } from "./data";

// 成员相关工具函数
export const memberUtils = {
  setRoomMembers(roomId: string, members: any[]) {
    roomData.roomMembers[roomId] = members.map(member => ({
      userId: member.userId,
      displayName: member.name,
      avatarUrl: member.avatarUrl,
      membership: member.membership
    }));
  },
  
  getRoomMembers(roomId: string) {
    return roomData.roomMembers[roomId] || [];
  },
  
  updateMember(
    roomId: string, 
    userId: string, 
    updates: {
      displayName?: string;
      avatarUrl?: string;
      membership: 'join' | 'invite' | 'leave' | 'ban';
    } & { [key: string]: any } // 允许其他属性
  ) {
    if (!roomData.roomMembers[roomId]) {
      roomData.roomMembers[roomId] = [];
    }
    
    const memberIndex = roomData.roomMembers[roomId].findIndex(m => m.userId === userId);
    if (memberIndex !== -1) {
      // 更新现有成员
      roomData.roomMembers[roomId][memberIndex] = {
        ...roomData.roomMembers[roomId][memberIndex],
        ...updates
      };
    } else {
      // 添加新成员
      const { membership, ...restUpdates } = updates;
      roomData.roomMembers[roomId].push({
        userId,
        displayName: userId.split('@')[0],
        avatarUrl: undefined,
        membership,
        ...restUpdates
      });
    }
  }
};
